var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(1 0 0 -1 9 85)",
    fill: "#9BCCE0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(1 0 0 -1 84 85)",
    fill: "#9BCCE0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(1 0 0 -1 46 85)",
    fill: "#9BCCE0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(1 0 0 -1 121 85)",
    fill: "#9BCCE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading1);
export default __webpack_public_path__ + "static/media/loading_1.46cb950534ba44b22875d35fe15a1535.svg";
export { ForwardRef as ReactComponent };